export const dateFormat = 'DD.MM.YYYY';
export const dateFormatLong = 'DD.MM.YYYY · HH:mm';
export default dateFormat;



// WEBPACK FOOTER //
// ./src/helpers/formats.js